import { render, staticRenderFns } from "./receiveInfo.vue?vue&type=template&id=48bb2f60&scoped=true"
import script from "./receiveInfo.vue?vue&type=script&lang=js"
export * from "./receiveInfo.vue?vue&type=script&lang=js"
import style0 from "./receiveInfo.vue?vue&type=style&index=0&id=48bb2f60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bb2f60",
  null
  
)

export default component.exports